module.exports = __webpack_public_path__ + "img/antes_despues_109.30316d04.png";